export default __webpack_public_path__ + "static/media/Pair programming-amico.ab7d00c0.svg";